var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVegan = function SvgVegan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Vegan_svg__a)",
    d: "M19.029 38C8.537 38 0 29.475 0 19 0 8.522 8.537 0 19.029 0s19.027 8.523 19.027 19c0 10.475-8.536 19-19.027 19m0-35.964C9.66 2.036 2.039 9.646 2.039 19S9.66 35.964 19.03 35.964s16.988-7.61 16.988-16.965S28.395 2.036 19.029 2.036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Vegan_svg__b)",
    d: "M10.336 9.71c.672-.231 1.298-.449 1.965-.68l6.21 17.947c.058-.146.096-.231.126-.325q1.032-3.104 2.069-6.206c.059-.18.064-.286-.113-.399-2.283-1.444-3.221-4.522-1.567-7.29.823-1.378 1.986-2.406 3.338-3.241a16 16 0 0 1 3.342-1.548c.2-.068.325-.051.456.14 1.219 1.762 2.135 3.654 2.453 5.792.236 1.599.083 3.161-.811 4.552-1.053 1.64-2.599 2.438-4.546 2.397-.399-.009-.535.115-.655.482-.911 2.798-1.851 5.583-2.767 8.373-.09.28-.22.371-.506.36a18 18 0 0 0-1.626 0c-.27.011-.377-.09-.46-.33-1.59-4.626-3.19-9.248-4.79-13.872q-.984-2.848-1.969-5.697c-.05-.14-.092-.28-.15-.46m14.148 5.997-1.023 3.09a3.06 3.06 0 0 0 1.625-.486c1.132-.727 1.498-1.852 1.55-3.106.072-1.75-.527-3.314-1.41-4.79-.016-.024-.057-.035-.096-.059-1.573.655-2.992 1.53-3.988 2.955-.622.885-1.04 1.844-.805 2.971.155.74.516 1.354 1.14 1.852.353-1.055.689-2.062 1.032-3.082l1.975.657"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Vegan_svg__a",
    x1: 9.514,
    x2: 34.833,
    y1: 0,
    y2: 38.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Vegan_svg__b",
    x1: 14.931,
    x2: 30.538,
    y1: 7.932,
    y2: 27.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgVegan;